'use client';

import Script from 'next/script';
import { GoogleAnalytics } from '@next/third-parties/google';

export default function GoogleTag() {
  return (
    <>
      <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID} />
      <Script
        dangerouslySetInnerHTML={{
          __html: `
          gtag('event', 'mind_balance_signup_success', {
            'page_path': '/signup/success'
          });
          `,
        }}
      />
    </>
  );
}
